import React, { FC } from 'react'
import classNames from 'classnames'

import StylesModule from 'components/lv2/TitleTextImage.module.scss'

export interface TitleTextImageProps {
  title: string
  text: string
  image: string
  addClassName: string
}

const TitleTextImage: FC<TitleTextImageProps> = ({
  title,
  text,
  image,
  addClassName,
}) => {
  return (
    <section
      className={classNames(
        StylesModule.titleTextImage,
        StylesModule[addClassName],
      )}
    >
      <h1 className={StylesModule.titleTextImage__title}>{title}</h1>
      <div className={StylesModule.titleTextImage__wrap}>
        <div
          className={StylesModule.titleTextImage__text}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
        <div className={StylesModule.titleTextImage__image}>
          <img src={image} area-hidden="true" alt="" />
        </div>
      </div>
    </section>
  )
}

export default TitleTextImage
